import React from 'react';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { OfferLayoutBaseProps, OfferLayoutLoadingProps } from '.';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1sl2unn",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1g8kjux",
  propsAsIs: false
});
const LeftWrapper = /*#__PURE__*/styled('div')({
  name: "LeftWrapper",
  class: "lnrx13f",
  propsAsIs: false
});
const RightWrapper = /*#__PURE__*/styled('div')({
  name: "RightWrapper",
  class: "rjx4ag6",
  propsAsIs: false
});
const CTAWrapper = /*#__PURE__*/styled('div')({
  name: "CTAWrapper",
  class: "c1w4jz9l",
  propsAsIs: false
});
export const PrimaryMultiColumnFullWidthCTALayout: React.FC<OfferLayoutBaseProps | OfferLayoutLoadingProps> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  ctaComponent,
  roomLabelsComponent,
  tagComponent,
  dataId
}) => {
  if (isLoading) return <Wrapper>
        <ContentWrapper>
          <div>
            <SkeletonLoader width={81} height={21} marginBottom={12} />
            <SkeletonLoader width={139} height={24} />
            <SkeletonLoader width={160} height={20} marginTop={4} />
          </div>
          <RightWrapper>
            <SkeletonLoader width={75} height={31} />
            <SkeletonLoader width={96} height={16} />
          </RightWrapper>
        </ContentWrapper>
        <SkeletonLoader height={48} />
      </Wrapper>;
  return <Wrapper data-id={dataId}>
      <ContentWrapper>
        <LeftWrapper>
          {tagComponent}
          {providerLogoComponent}
          {roomLabelsComponent}
        </LeftWrapper>
        <RightWrapper>{priceComponent}</RightWrapper>
      </ContentWrapper>
      <CTAWrapper>{ctaComponent}</CTAWrapper>
    </Wrapper>;
};

require("./PrimaryMultiColumnFullWidthCTALayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PrimaryMultiColumnFullWidthCTALayout.tsx");